import { animate, state, style, transition, trigger } from '@angular/animations';

export const fadeOut = trigger('fadeOut', [
  state(
    'void',
    style({
      opacity: 0,
    }),
  ),
  transition('* => void', [animate('500ms ease-out')]),
]);
